import { HStack, Text, VStack, Box, Spinner } from "@chakra-ui/react";
import { useMemberSignedIn } from "modules/members/auth";
import {
  createBrowserRouter,
  Navigate,
  Outlet,
  useParams,
} from "react-router-dom";
import { membersRoutes } from "./Members";
import { Suspense } from "react";

const MemberRoot = () => {
  const signedIn = useMemberSignedIn();
  const path = window.location.pathname;
  const params = useParams();
  const searchParams = new URLSearchParams(window.location.search);
  const key = searchParams.get("key");
  // `?auth=<provider>` is for the sign-in page, not for after it.
  const auth = searchParams.get("auth");
  const authParam = auth ? `&auth=${encodeURIComponent(auth)}` : "";
  const catalog = params["slug"];
  const rParams = new URLSearchParams(window.location.search);
  rParams.delete("key");
  rParams.delete("auth");
  const redirectPath =
    window.location.pathname + "?" + encodeURI(rParams.toString());
  return signedIn ||
    path.startsWith("/members/auth") ||
    // Dev-only design-system gallery + scratch demos skip auth; compile away in
    // prod where the routes don't exist.
    (!import.meta.env.PROD &&
      (path.startsWith("/members/_ds-preview") ||
        path.startsWith("/members/_scratch"))) ? (
    <Suspense fallback={<Spinner />}>
      <Outlet />
    </Suspense>
  ) : (
    <Navigate
      replace
      to={`/members/auth/sign-in?member_id=${params.member_id}&key=${key}&redirectTo=${redirectPath}&catalog=${catalog}${authParam}`}
    />
  );
};

let router;
router = createBrowserRouter([
  {
    path: "/",
    element: <MemberRoot />,
    ErrorBoundary: () => {
      return (
        <VStack width="100%" spacing={4}>
          <VStack spacing={0}>
            <Text fontSize="5xl" fontWeight="bold">
              Something went wrong
            </Text>
            <Text fontSize="2xl">Looks like we've made a mistake.</Text>
          </VStack>
          <Text>Sorry about this, we should have it fixed soon.</Text>
        </VStack>
      );
    },
    children: [...membersRoutes],
  },
]);

// Create a root route
export default router;
